import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import {
  useDeleteAdminMutation,
  useEditAdminMutation,
  useGetAdminsQuery,
} from "../../store/Api/admins";
import { hidetoast, useDecodeToken } from "../../Utils/function";
import { useGetRrbQuery } from "../../store/Api/common";
import AuditsFormExtrasUi from "./AuditsFormExtrasUi";
import {
  useDeleteAuditFormExtrasMutation,
  useEditAuditsFormExtrasMutation,
  useGetAuditsFormExtrasQuery,
} from "../../store/Api/auditsFormExtras";
import { useDispatch, useSelector } from "react-redux";
import { encryptId } from "../../Utils/crypto";
import  {rowsPerPage} from '../../Utils/constant'

function AuditsFormExtras() {
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState("");
  const decodedToken = useDecodeToken();
  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage: rowsPerPage,
    currentPage: 1,
  });
  const [deleteAuditFormExtras] = useDeleteAuditFormExtrasMutation();
  const [updateAdmin] = useEditAuditsFormExtrasMutation();
  const { data, isFetching, isLoading, refetch } = useGetAuditsFormExtrasQuery({
    search: tableQaury.search,
    limit: tableQaury.rowsPerPage,
    page: tableQaury.currentPage,
  });
  // const onUpdate=(adminData)=>{
  //     navigate(`/update-admin/${adminData}`,{state:{adminData}})
  // }
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);

  // Auto-hide toast after 3 seconds
 useEffect(() => {
    if (toast.message) {
       hidetoast()
    }
  }, [toast.message, dispatch]);
  const onUpdate = async (row) => {
  
    
    navigate(`/update-audit-extras`, { state: { row } });
    // try {
    //   const response = await updateAdmin({ id: userId, status: newstatus });
    //   if (response?.data?.success) {
    //     refetch(); // Refresh the user list after updating
    //   }
    // } catch (error) {
    //   console.error(error, "Error updating user status");
    // }
  };
  const deleteAdminFn = async () => {
    try {
      const response = await deleteAuditFormExtras({ id: deleteId });
      if (response?.data?.success) {
        // Call refetch to refresh the user list
        refetch();
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    setTableQaury({ ...tableQaury, currentPage: newPage });
  };
  const columns = [
    { title: "Title", dataKey: "title" },
    {
      title: "Phone Number",
      dataKey: "phone_number",
      render: (text, row) => (
        <span>{row.phone_number ? " Mandatory" : "-"}</span>
      ),
    },
    {
      title: "Designation",
      dataKey: "designation",
      render: (text, row) => (
        <span>{row.designation ? "Mandatory" : "-"}</span>
      ),
    },
    { title: "Description", dataKey: "description" },
    {
      title: "Actions",
      render: (_, row) => (
        <div className="d-flex">
          {/* <button className="border-0 bg-transparent">
            <i class="fas fa-eye text-primary"></i>
          </button> */}
          <button
            className="border-0 bg-transparent"
            type="button"
            onClick={() => onUpdate(row)}
          >
            <i className="fas fa-edit text-success"> </i>
          </button>
          <button
            className="border-0 bg-transparent"
            type="button"
            data-toggle="modal"
            data-target="#modal-danger"
            onClick={() => setDeleteId(row?.id)}
          >
            <i className="fas fa-trash text-danger"> </i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <Layout>
      <AuditsFormExtrasUi
        columns={columns}
        data={data?.data || []}
        totalRecords={data?.data?.totalItems}
        onUpdate={onUpdate}
        loading={isLoading}
        tableQaury={tableQaury}
        deleteAdminFn={deleteAdminFn}
        onPageChange={handlePageChange}
        setTableQaury={setTableQaury}
        decodedToken={decodedToken}
        toast={toast}
      />
    </Layout>
  );
}

export default AuditsFormExtras;
